import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CategoryService } from '../../../../../core/lists';
import { FormControl } from '@angular/forms';
import { AuthService } from '../../../../../core/auth';
import { GeneralAutocompleteComponent } from '../../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { MatDialogRef } from '@angular/material/dialog';
import { CompaniesService, CompanyModel } from '../../../../../core/management';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kt-copy-role-permission-dialog',
  templateUrl: './copy-role-permission-dialog.component.html',
  styleUrls: ['./copy-role-permission-dialog.component.scss'],
})
export class CopyRolePermissionDialogComponent implements OnInit, OnDestroy {
  categoryAutocompleteCall = this.categoryService.searchCategories.bind(this.categoryService);
  roleCtrl = new FormControl();
  role = null;
  companiesList: CompanyModel[];
  searchRolesFn = this.authService.searchRolesByCompany.bind(this.authService, '');
  formatNewRoleFn = ((value) => {
    return value;
  }).bind(this);
  private subscriptions: Subscription[] = [];
  isSuperAdmin = false;
  @ViewChild('roleAutocomplete') roleAutocomplete: GeneralAutocompleteComponent;
  private selectedRole: any;
  disableBtns = false;

  constructor(
    private categoryService: CategoryService,
    private companiesService: CompaniesService,
    public authService: AuthService,
    public dialogRef: MatDialogRef<CopyRolePermissionDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.authService.currentUser.subscribe((res) => {
        if (res && res.typeRole === 'Super Admin') {
          this.isSuperAdmin = true;
          this.companiesService
            .getAllCompanies()
            .subscribe((result) => (this.companiesList = result));
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  onSubmit() {
    if (this.roleAutocomplete.controlObject.invalid) {
      this.roleAutocomplete.updateValueAndValidity();
      return;
    }
    this.disableBtns = true;
    this.authService
      .findRoles({
        filter: { title: this.selectedRole.name, searchData: this.selectedRole.name },
        pageNumber: 0,
        pageSize: 10,
        sortField: 'id',
        sortOrder: 'asc',
      })
      .subscribe((res) => {
        this.dialogRef.close(
          res &&
            res.pageOfItems &&
            res.pageOfItems[0] &&
            res.pageOfItems[0].permissions &&
            res.pageOfItems[0].permissions.length
            ? res.pageOfItems[0].permissions
            : [],
        );
      });
  }

  filterRoleFn(event: any): string {
    return event ? event.name : '';
  }

  selected(val): void {
    this.selectedRole = val;
  }

  selectCompany() {
    this.searchRolesFn = this.authService.searchRolesByCompany.bind(
      this.authService,
      '&company_id=' + this.role,
    );
  }
}
